import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a88345de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userProfileView" }
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = { class: "profile-meta" }
const _hoisted_4 = { class: "profile-name" }

import { reactive, ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { UserControllerService } from "../../../generated";
import message from "@arco-design/web-vue/es/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileView',
  setup(__props) {

const store = useStore();
const loading = ref(false);

const loginUser = computed(() => store.state.user.loginUser);

const form = reactive({
  userName: "",
  userProfile: "",
});

const rules = {
  userName: [{ required: true, message: "用户名不能为空" }],
};

onMounted(() => {
  const user = loginUser.value;
  if (user?.id) {
    form.userName = user.userName || "";
    form.userProfile = user.userProfile || "";
  }
});

const handleSave = async () => {
  loading.value = true;
  try {
    const res = await UserControllerService.updateMyUserUsingPost({
      userName: form.userName,
      userProfile: form.userProfile,
    });
    if (res.code === 0) {
      message.success("修改成功");
      await store.dispatch("user/getLoginUser");
    } else {
      message.error("修改失败，" + res.message);
    }
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "个人中心",
      bordered: false,
      style: {"max-width":"600px","margin":"0 auto"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_avatar, {
            size: 64,
            class: "profile-avatar"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(loginUser.value?.userName?.substring(0, 1) || "U"), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(loginUser.value?.userName || "未登录"), 1),
            (loginUser.value?.userRole === 'admin')
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 0,
                  color: "orangered",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 管理员 ")
                  ]),
                  _: 1
                }))
              : (loginUser.value?.id)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "blue",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 普通用户 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_a_divider),
        _createVNode(_component_a_form, {
          model: form,
          rules: rules,
          layout: "vertical",
          onSubmit: handleSave,
          style: { marginTop: '16px' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "userName",
              label: "用户名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: form.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userName) = $event)),
                  placeholder: "请输入用户名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userProfile",
              label: "个人简介"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  modelValue: form.userProfile,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userProfile) = $event)),
                  placeholder: "介绍一下自己吧",
                  "max-length": 200,
                  "auto-size": { minRows: 3, maxRows: 6 },
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  loading: loading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 保存修改 ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})